import * as React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./PrwPhoneNumber.scss";

const PrwPhoneNumber = (props: any) => {

  return (
    <div>
      <PhoneInput
        international
        value={props.value}
        onChange={(e: any) => props.onChange(e)}
      />
    </div>
  );
};

export default PrwPhoneNumber;
